import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { IconComponent } from '@shared/components/icon/icon.component';

import { TrialInsightsClinicalScreenFailChartService } from './screen-fail-chart.service';
import { TrialInsightsClinicalScreenFailQueryService } from './screen-fail-query.service';
import { TrialInsightsClinicalScreenFailStoreService } from './screen-fail-store.service';
import { TrialInsightsClinicalScreenFailTableService } from './screen-fail-table.service';
import { GenericTrialInsightsComponent } from '../../classes/trial-insights-component.class';
import { TrialInsightsHeaderComponent } from '../trial-insights-header/trial-insights-header.component';
import { TrialInsightsLegendComponent } from '../trial-insights-legend/trial-insights-legend.component';
import { TrialInsightsTableComponent } from '../trial-insights-table/trial-insights-table.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TrialInsightsHeaderComponent,
    IconComponent,
    NgStyle,
    TrialInsightsLegendComponent,
    TrialInsightsTableComponent,
  ],
  providers: [TrialInsightsClinicalScreenFailQueryService],
  selector: 'aux-trial-insights-clinical-screen-fail',
  styleUrls: ['../../trial-insights.component.scss'],
  templateUrl: './screen-fail.component.html',
})
export class TrialInsightsClinicalScreenFailComponent extends GenericTrialInsightsComponent {
  storeService = inject(TrialInsightsClinicalScreenFailStoreService);

  cdr: ChangeDetectorRef;
  chartService: TrialInsightsClinicalScreenFailChartService;
  queryService: TrialInsightsClinicalScreenFailQueryService;
  tableService: TrialInsightsClinicalScreenFailTableService;

  constructor() {
    const chartService = inject(TrialInsightsClinicalScreenFailChartService);
    const tableService = inject(TrialInsightsClinicalScreenFailTableService);
    const queryService = inject(TrialInsightsClinicalScreenFailQueryService);
    const cdr = inject(ChangeDetectorRef);

    super({
      cdr,
      chartService,
      color: '#3d444a',
      queryService,
      tableService,
      title: 'Screen Fails',
    });

    this.chartService = chartService;
    this.tableService = tableService;
    this.queryService = queryService;
    this.cdr = cdr;
  }

  subscribeToData = () => {
    this.queryService
      .processScreenFailSummary$()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
    this.storeService.getScreenFailSummary$().pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
  };
}
